var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){_vm.pointFn(_vm.linkProps(_vm.to || _vm.item.url || _vm.item.path))}}},[_c(_vm.type,_vm._b({tag:"component"},'component',{ ..._vm.linkProps(_vm.to || _vm.item.url || _vm.item.path), ..._vm.$attrs },false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }